import { useOidcWithAdmin } from '@revenuewell/logic-oidc';
import { useProxy } from '@revenuewell/logic-wrapper-proxy';
import React, { useEffect, useState } from 'react';
import { SelectedLocationContext } from './selected-location-context';
import { SelectedLocation } from './types/selected-location';

export const SelectedLocationProvider = (props: any) => {
  const { children } = props;
  const { getClaims } = useOidcWithAdmin();
  const { proxy, sendEvent, listenEvent } = useProxy();
  const [isReady, setIsReady] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<SelectedLocation>({ locationId: 0 });

  const handleLocationChange = (event: any) => {
    const { data } = event as { data: { locationId: number; name: string } };
    setSelectedLocation(data);
    setIsReady(true);
  };

  useEffect(() => {
    if (!proxy) return;

    (async () => {
      const claims = await getClaims();

      setSelectedLocation({ locationId: claims.locationId });
      sendEvent({ messageType: 'getActiveLocation' } as any);
      // if wrapper does not respond in 1 second, we will proceed with claims location id
      setTimeout(() => setIsReady(true), 1000);

      const listener1 = listenEvent('locationChanged' as any, handleLocationChange);
      const listener2 = listenEvent('activeLocation' as any, handleLocationChange);

      return () => {
        listener1();
        listener2();
      };
    })();
  }, [proxy]);

  return (
    <SelectedLocationContext.Provider value={{ selectedLocation }}>
      {(isReady || !proxy) && children}
    </SelectedLocationContext.Provider>
  );
};
